import { render, staticRenderFns } from "./ImportsCom.vue?vue&type=template&id=70da2064&scoped=true&"
import script from "./ImportsCom.vue?vue&type=script&lang=js&"
export * from "./ImportsCom.vue?vue&type=script&lang=js&"
import style0 from "./ImportsCom.vue?vue&type=style&index=0&id=70da2064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da2064",
  null
  
)

export default component.exports